module.exports = __webpack_public_path__ + "img/武邑保险柜金属橱柜.aeeeefa4.jpg";